import _ from 'lodash'
import arrayToTree from 'array-to-tree'

/**
 * Lodash mixins.
 */
_.mixin({
  /** Deletes own properties of an object. */
  clearObject: obj => Object.keys(obj).forEach(key => delete obj[key]),
  /** Converts a string to a machine friendly name. */
  machineName: string =>
    string
      .toLocaleLowerCase()
      .replace(/[àáäâ]/g, 'a')
      .replace(/[èéëê]/g, 'e')
      .replace(/[ìíïî]/g, 'i')
      .replace(/[òóöô]/g, 'o')
      .replace(/[ùúüû]/g, 'u')
      .replace(/[^A-Za-z0-9 ]/g, '')
      .replace(/\s{2,}/g, ' ')
      .replace(/\s/g, '-'),
  /** Adds a value to an array, if absent; removes it if present. Returns true if the value was added. */
  toggle: (arr, value) => {
    let idx =
      typeof value === 'object' ? _.find(arr, value) : arr.indexOf(value)
    let add = idx === -1 || idx === undefined
    if (add) arr.push(value)
    else arr.splice(idx, 1)
    return add
  },
  /**
   * Builds a tree of resources grouped by parent.
   *
   * @prop {array<TmrResource>} list
   */
  tree(list) {
    // Add empty children so tree widgets always have a drop zone.
    list.forEach(resource => (resource.children = []))
    return arrayToTree(list, { parentProperty: 'parent.id' })
  },
  /**
   * Like `includes`, but case insensitive.
   *
   * @param {string} value
   * @param {string} testValue
   */
  iIncludes(value, testValue) {
    return value.toLocaleLowerCase().indexOf(testValue.toLocaleLowerCase()) > -1
  },
})
